<template>
  <div id="contact-page">
    <ParallaxHeader :headline="'Contact Us'" :slogan="'Get in touch with our support staff'"/>
  <v-container fluid grid-list-xl>
    <v-layout row wrap justify-center>
      <!-- <v-flex xs12 sm8 md6 xl4> -->
      <v-flex xs12 md6 lg4 xl3>
        <v-card>
          <v-container>
            <h2 class="headline">We'd Love to hear from you</h2>
            <p class="body-1">To request more information, please fill out and submit the form below</p>
            <contact-form></contact-form>
          </v-container>
        </v-card>
      </v-flex>
      <!-- <v-flex xs12 sm6 md3> -->
      <v-flex xs12 md6 lg4 xl3>
        <v-card>
          <v-container>
            <iframe scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com.au/maps?hl=en&amp;ie=UTF8&amp;q=bezzina+group&amp;fb=1&amp;gl=au&amp;hq=bezzina+group&amp;hnear=0x6b12c81235d88f33:0x5017d681632b360,Cronulla+NSW&amp;cid=0,0,735132850336761037&amp;t=m&amp;ll=-34.052108,151.155546&amp;spn=0.006222,0.00912&amp;z=16&amp;iwloc=A&amp;output=embed" width="100%" height="450" frameborder="0"></iframe>
            <br>
            <small><a href="https://maps.google.com.au/maps?hl=en&amp;ie=UTF8&amp;q=the+promenade+cronulla&amp;fb=1&amp;gl=au&amp;hq=the+promenade&amp;hnear=0x6b12c81235d88f33:0x5017d681632b360,Cronulla+NSW&amp;cid=0,0,735132850336761037&amp;t=m&amp;ll=-34.052108,151.155546&amp;spn=0.006222,0.00912&amp;z=16&amp;iwloc=A&amp;source=embed" style="color:#0000FF;text-align:left">View Larger Map</a></small> 
          </v-container>
        </v-card>
        <v-card v-if="aboutData.length > 0" v-for="(item, index) in aboutData" :key="index">
          <v-container>
            <div style="text-align:center;">
              <h2 class="display-1">{{ item.title }}</h2>
              <hr class="buzz-hr">
              <p v-if="item.address !== ''" class="content-text">{{ item.address }}</p>
              <p v-if="item.telephone !== ''" class="content-text"><v-icon>{{ "fa fa-2x fa-phone" }}</v-icon> : {{ item.telephone }}</p>
              <p v-if="item.fax !== ''" class="content-text"><v-icon>{{ "fa fa-2x fa-fax" }}</v-icon> : {{ item.fax }}</p>
              <p class="content-text"><v-icon>{{ "fa fa-2x fa-envelope" }}</v-icon> :  {{ item.email }}</p>
            </div>
          </v-container>
        </v-card>
        <!-- <v-card color="grey lighten-5">
          <v-container>
            <div style="text-align:center;">
              <h2 class="display-1">Property &amp; Sales</h2>
              <hr class="buzz-hr">
              <p class="content-text"><v-icon>{{ "fa fa-2x fa-envelope" }}</v-icon> : sales@bezzina.com.au</p>
            </div>
          </v-container>
        </v-card> -->
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'
import CopyrightComponent from '@/components/CopyrightComponent.vue'
import ParallaxHeader from '@/components/ParallaxHeader'
import Api from '@/api'

export default {
  data () {
    return {
      aboutData: []
    }
  },
  components: {
    'contact-form': ContactForm,
    'copyright-component': CopyrightComponent,
    ParallaxHeader
  },
  beforeMount () {
    this.getContactsData()
  },
  methods: {
    getContactsData () {
      const path = '/company-contact'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            // console.log(response.data.about)
            this.aboutData = response.data.companycontact
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
#contact-page {
  font-family: 'Lato', sans-serif;
  font-size: 1.2vmax;
}
#slogan {
  font-size: 2vmax;
  font-family: 'Vollkorn', serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.page-subheading {
  font-size: 2vmax;
}
</style>


// WEBPACK FOOTER //
// src/pages/ContactsPage.vue